import { Injectable, signal, effect } from '@angular/core';

const SIDEBAR_EXPANDED_KEY = 'of_sidebar_expanded';

@Injectable({ providedIn: 'root' })
export class SidebarStateService {
  readonly expanded = signal(localStorage.getItem(SIDEBAR_EXPANDED_KEY) !== 'false');

  constructor() {
    effect(() => {
      localStorage.setItem(SIDEBAR_EXPANDED_KEY, String(this.expanded()));
    });
  }

  toggle(): void {
    this.expanded.update((v) => !v);
  }
}
